import {layoutMarkup} from "../layout/layoutMarkup.js";
import {layoutPublicMarkup} from "../layout/layoutPublicMarkup";
import {timelineDefaultContent} from './timelineSectionDefaultContent';
import l10n from "../../../lang/locallang";
import {componentsHelper} from "../../helpers/componentsHelper";

const timelineSection = (param, is_public = false) => {
    componentsHelper.updateLocalization(timelineDefaultContent);
    const { timelineTexts } = l10n;
    const { date, heading, addNewItem } = l10n.editor;
    param.class = param.class ? param.class : 'editor-section';
    param.content = param.content ? param.content : ``;
    param.style = param.style ? param.style : '';
    param.layout = param.layout ? param.layout : '';
    param.section = 'timelineSection';
    let items = `
        <div class="timeline-item">
            <div class="timeline-item_content">
                <span class="subheading editable-text" ${!is_public ? `contenteditable="true" placeholder="${date}"` : ''}>${timelineTexts[0].subheading}</span>
                <span class="heading editable-text" ${!is_public ? `contenteditable="true" placeholder="${heading}"` : ''}>${timelineTexts[0].heading}</span>
                <div class="fr-editor-paragraph">
                    <p>${timelineTexts[0].text}</p>
                </div>
            </div>
            ${!is_public ? `<button class="timeline-item-delete"><i class="icon icon-trash"></i></button>` : ''}
        </div>
        <div class="timeline-item">
            <div class="timeline-item_content">
                <span class="subheading editable-text" contenteditable="true" placeholder="${date}">${timelineTexts[1].subheading}</span>
                <span class="heading editable-text" contenteditable="true" placeholder="${heading}">${timelineTexts[1].heading}</span>
                <div class="fr-editor-paragraph">
                    <p>${timelineTexts[0].text}</p>
                </div>
            </div>
            ${!is_public ? `<button class="timeline-item-delete"><i class="icon icon-trash"></i></button>` : ''}
        </div>`;
    if(param.content){
        if(param.content.timeline){
            items = '';
            for(let item of param.content.timeline){
                items += `<div class="timeline-item">
                    <div class="timeline-item_content">
                        <span class="subheading editable-text" ${!is_public ? `contenteditable="true" placeholder="${date}"` : ''}>${item.date}</span>
                        <span class="heading editable-text" ${!is_public ? `contenteditable="true" placeholder="${heading}"` : ''}>${item.title}</span>
                        <div class="fr-editor-paragraph">
                            ${item.text}
                        </div>
                    </div>
                    ${!is_public ? `<button class="timeline-item-delete"><i class="icon icon-trash"></i></button>` : ''}
                </div>`;
            }
        }
    }
    param.component = `
            <div class="editor-timeline">
                ${items}
            </div>
            ${!is_public ? `
            <div class="add-new-timeline">
                <button class="btn btn-add-timeline"><i class="icon icon-add"></i><span>${addNewItem}</span></button>
            </div>
            ` : ''}`;
    if(is_public){
        return layoutPublicMarkup(param);
    } else {
        return layoutMarkup(param);
    }
}

export {timelineSection};
